<template>
  <div class="ownerDetail">
    <div class="titleWrap">
      <div class="setTitle">{{ ownerName }}</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/owner' }">业主列表</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="clearfix"></div>
    </div>
    <div class="contentWrap">
      <div class="infoWrap">
        <div class="infoHeader">基本信息</div>
        <el-button class="myBtn" type="primary" plain size="small" v-if="orgId !== ''" @click="importPic('')">人脸设置</el-button>
        <div class="infoDiv">
          <span class="infoTitle">业主姓名：</span>
          <span class="infoContent">{{ ownerName }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">身份证号：</span>
          <span class="infoContent">{{ ownerCode }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">性别：</span>
          <span class="infoContent">{{ sex }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">联系电话：</span>
          <span class="infoContent">{{ phone }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">业主类型：</span>
          <span class="infoContent">{{ ownerTypeValue }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">注册时间：</span>
          <span class="infoContent">{{ registrationTime }}</span>
        </div>
        <div class="infoDiv">
          <span class="infoTitle">备注：</span>
          <span class="infoContent">{{ remark }}</span>
        </div>
        <div class="notImage" v-if="photoList.length === 0">照片未上传</div>
        <img class="photo" :src="item.url" width="96" height="96" alt="照片获取失败" v-for="(item, index) in photoList" :key="index">
      </div>
      <div class="otherWrap">
        <div class="bluetoothWrap">
          <div class="bluetoothHeader">蓝牙信息</div>
          <div class="bluetoothDiv">
            <span class="bluetoothTitle">蓝牙号：</span>
            <span class="bluetoothContent">{{ bluetoothNumber }}</span>
          </div>
          <div class="bluetoothDiv">
            <span class="bluetoothTitle">起始时间：</span>
            <span class="bluetoothContent">{{ bluetoothStartTime }}</span>
          </div>
          <div class="bluetoothDiv">
            <span class="bluetoothTitle">截止时间：</span>
            <span class="bluetoothContent">{{ bluetoothEndTime }}</span>
          </div>
          <el-button class="delBtn" type="primary" plain size="small" v-if="bluetoothId !== ''" @click="bluetoothDel">删除</el-button>
        </div>
        <div class="codeWrap">
          <div class="codeHeader">二维码信息</div>
          <div class="codeDiv">
            <span class="codeTitle">二维码号：</span>
            <span class="codeContent">{{ codeNumber }}</span>
          </div>
          <div class="codeDiv">
            <span class="codeTitle">起始时间：</span>
            <span class="codeContent">{{ codeStartTime }}</span>
          </div>
          <div class="codeDiv">
            <span class="codeTitle">截止时间：</span>
            <span class="codeContent">{{ codeEndTime }}</span>
          </div>
          <el-button class="delBtn" type="primary" plain size="small" v-if="codeId !== ''" @click="codeDel">删除</el-button>
        </div>
      </div>
    </div>
    <el-main class="tableWrap">
      <div class="tableTitle">成员列表<span class="explain">（至多十五位）</span></div>
      <!-- 成员最多15个 -->
      <el-button class="addBtn" type="primary" size="small" v-if="orgId !== ''" :disabled="familyAttr.length >= 15" @click="add">新增</el-button>
      <div class="clearfix"></div>
      <el-table :data="familyAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :align="align"></el-table-column>
        <el-table-column prop="ownerType" label="用户类型" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="userType family" v-if="scope.row.ownerType === 2"></div>
            <div class="userType tenant" v-if="scope.row.ownerType === 3"></div>
            <span v-if="scope.row.ownerType === 2">家人</span>
            <span v-if="scope.row.ownerType === 3">租客</span>
          </template>
        </el-table-column>
        <el-table-column prop="owner" label="用户姓名" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="idCard" label="身份证" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="sex" label="性别" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ getSex(scope.row.sex) }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系方式" min-width="180" :align="align"></el-table-column>
        <el-table-column fixed="right" min-width="250" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="orgId !== ''" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="orgId !== ''" @click="del(scope.row.id, scope.row.ownerCodes, scope.row.roomPics)">删除</el-button>
            <el-button type="text" size="small" v-if="orgId !== ''" @click="importPic(scope.row.id)">人脸设置</el-button>
            <el-button type="text" size="small" @click="byLiftRecord(scope.row.ownerId, scope.row.roomId, scope.row.owner)">乘梯记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total" :total="familyTotal"></el-pagination>
    </el-main>
    <!-- 人脸设置弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-form-item label="业主照片">
          <el-upload ref="upload" action="" list-type="picture-card" :multiple="false" :auto-upload="false" :limit="6" accept=".png,.jpg,.jpeg" :file-list="form.fileList" :on-change="upload" :on-exceed="explainFile" :on-remove="delFile">
            <i class="el-icon-plus"></i>
            <span class="uploadText">单击上传</span>
            <div slot="tip" class="el-upload__tip">图片比例1:1，图片小于2M，支持png、jpg、jpeg格式，最多上传6张</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增编辑成员弹出层 -->
    <el-dialog :visible.sync="familyDialog" :title="familyTitle" width="500px" :close-on-click-modal="false" @close="familyNotBtn">
      <el-form ref="familyForm" :model="familyForm" :rules="familyRules" label-width="100px" size="small">
        <el-form-item label="用户姓名" prop="userName">
          <el-input v-model.trim="familyForm.userName" placeholder="用户姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="userType">
          <el-select class="select" v-model="familyForm.userType" filterable clearable size="small" placeholder="用户类型">
            <el-option v-for="item in familyForm.userTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号" prop="userCode">
          <el-input v-model.trim="familyForm.userCode" placeholder="身份证号" :disabled="familyForm.userId !== ''" :maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model.trim="familyForm.phoneNumber" placeholder="联系电话" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="familyForm.sex" filterable clearable placeholder="性别">
            <el-option v-for="item in familyForm.sexList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="familyNotBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="familyLoading" @click="familyOkBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OwnerDetail',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      myLocation: window.location.origin, // 当前域名
      setMinTime: { // 日期大于当前
        disabledDate: time => {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      villageId: '', // 小区Id
      orgId: '', // 登录时的小区Id
      roomId: '', // 房间Id
      villageCode: '', // 小区号
      ownerId: '', // 业主Id
      ownerRoomId: '', // 业主房间Id
      ownerInfo: '', // 业主基础信息
      ownerName: '', // 业主姓名
      ownerCode: '', // 身份证号
      sex: '', // 性别
      phone: '', // 联系电话
      ownerType: '', // 业主类型
      ownerTypeValue: '', // 业主类型展示
      registrationTime: '', // 注册时间
      remark: '', // 备注
      photoList: [], // 照片列表
      bluetoothId: '', // 蓝牙Id
      bluetoothNumber: '', // 蓝牙号
      bluetoothStartTime: '', // 蓝牙起始时间
      bluetoothEndTime: '', // 蓝牙截止时间
      codeId: '', // 二维码Id
      codeNumber: '', // 二维码号
      codeCopyNumber: '', // 二维码防伪
      codeStartTime: '', // 二维码起始时间
      codeEndTime: '', // 二维码截止时间
      familyAttr: [], // 成员列表
      familyTotal: 0, // 成员总数
      familyId: '', // 成员房间Id
      familyBluetooth: '', // 成员蓝牙号
      familyCode: '', // 成员二维码号
      familyPic: '', // 成员照片组
      dialog: false, // 人脸设置出层状态
      title: '', // 人脸设置出层标题
      form: {
        fileList: [], // 已上传照片组
        fileArr: [] // 传给后台的照片组
      },
      faceObj: {}, // 人脸设备对象数据
      faceArr: [], // 人脸设备数组
      picType: '', // 照片用户类型
      picUrl: '', // 当前照片地址
      picId: '', // 当前照片Id
      familyTitle: '', // 成员弹出层标题
      familyDialog: false, // 成员弹出层状态
      familyLoading: false, // 成员弹出层确定按钮loading
      familyForm: {
        userId: '', // 成员Id
        userName: '', // 成员姓名
        userType: '', // 成员类型
        userTypeList: [], // 成员类型下拉框
        userCode: '', // 身份证号
        phoneNumber: '', // 联系电话
        sex: '', // 性别
        sexList: [] // 性别下拉框
      },
      familyRules: {
        userName: [
          {
            required: true,
            message: '请输入用户姓名',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('用户姓名由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        userType: [
          {
            required: true,
            message: '请选择用户类型',
            trigger: 'change'
          }
        ],
        userCode: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value) || value.length < 18) {
                callback(new Error('身份证号由18位数字和英文字母组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ]
      },
      familyRoomId: '', // 成员房间关联Id
      familyCard: '', // 成员身份证
      familyName: '', // 成员姓名
      delFamilyRoomId: '', // 删除的成员房间关联Id
      emqTime: null, // emq超时定时器
      client: null, // MQTT对象
      host: this.$host, // MQTT地址
      port: this.$port, // MQTT地址端口号
      clientId: 'WEB:' + new Date().getTime().toString(), // MQTT对象Id，当前时间
      username: this.$store.state.user.username, // MQTT访问的用户名
      password: this.$store.state.user.password // MQTT访问的密码
    }
  },
  mounted () {
    // 登录时的小区Id
    this.orgId = this.$store.state.user.villageId
    // 小区Id
    this.villageId = this.$route.query.villageId
    // 房间Id
    this.roomId = this.$route.query.roomId
    // 业主Id
    this.ownerId = this.$route.query.ownerId
    // 业主房间Id
    this.ownerRoomId = this.$route.query.ownerRoomId
    // 业主姓名
    this.ownerName = decodeURI(decodeURI(this.$route.query.ownerName))
    // 获取业主基本信息
    this.getOwnerInfo()
    // 获取业主蓝牙、二维码
    this.getLiftCode()
    // 拿人脸设备
    this.$http.get(this.$api.owner_detail, {
      params: {
        ownerId: this.ownerId,
        ownerRoomId: this.ownerRoomId
      }
    }).then((res) => {
      let data = res.data

      if (data.data.success) {
        this.ownerInfo = data.data.data[0]
        this.faceObj = data.data.data[0].json
        this.faceArr = this.faceObj.face
      } else {
        this.$message({
          type: 'error',
          message: data.data.errMsg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取用户类型下拉框数据
    this.familyForm.sexList = [
      {
        key: 0,
        value: '女'
      },
      {
        key: 1,
        value: '男'
      }
    ]
    // 获取性别下拉框数据
    this.familyForm.userTypeList = [
      {
        key: 2,
        value: '家人'
      },
      {
        key: 3,
        value: '租户'
      }
    ]
    // 获取房间列表
    this.getFamilyList()
  },
  methods: {
    getOwnerInfo () {
      this.photoList = []
      this.$http.get(this.$api.owner_info, {
        params: {
          ownerRoomId: this.ownerRoomId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.ownerName = data.data.data.owner
          this.ownerCode = data.data.data.idCard
          this.phone = data.data.data.phone
          if (data.data.data.sex === 0) {
            this.sex = '女'
          }
          if (data.data.data.sex === 1) {
            this.sex = '男'
          }
          this.ownerType = data.data.data.ownerType
          if (data.data.data.ownerType === 0) {
            this.ownerTypeValue = '普通业主'
          }
          if (data.data.data.ownerType === 1) {
            this.ownerTypeValue = '业主代表'
          }
          this.registrationTime = data.data.data.createDate.substr(0, 4) + '-' + data.data.data.createDate.substr(5, 2) + '-' + data.data.data.createDate.substr(8, 2)
          this.remark = this.$null(data.data.data.remark)
          if (data.data.data.roomPics !== '' && data.data.data.roomPics !== null) {
            let photoArr = data.data.data.roomPics.split(',')
            for (let i = 0; i < photoArr.length; i++) {
              this.photoList.push({
                url: this.$url + this.$api.file_download + '?id=' + photoArr[i]
              })
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getLiftCode () {
      this.$http.get(this.$api.owner_code, {
        params: {
          ownerRoomId: this.ownerRoomId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          if (data.data.length === 0) {
            this.codeId = ''
            this.codeNumber = '-'
            this.codeStartTime = '-'
            this.codeEndTime = '-'
            this.bluetoothId = ''
            this.bluetoothNumber = '-'
            this.bluetoothStartTime = '-'
            this.bluetoothEndTime = '-'
          } else if (data.data.length === 1) {
            // 二维码
            if (data.data[0].passType === 1) {
              this.codeId = data.data[0].id
              this.codeNumber = this.$null(data.data[0].passCode)
              this.codeCopyNumber = data.data[0].createTimeStamp
              if (data.data[0].effectiveTime === null || data.data[0].effectiveTime === '') {
                this.codeStartTime = '-'
              } else {
                this.codeStartTime = data.data[0].effectiveTime.substr(0, 4) + '-' + data.data[0].effectiveTime.substr(5, 2) + '-' + data.data[0].effectiveTime.substr(8, 2) + ' ' + data.data[0].effectiveTime.substr(11, 2) + ':' + data.data[0].effectiveTime.substr(14, 2) + ':' + data.data[0].effectiveTime.substr(17, 2)
              }
              if (data.data[0].expireDate === null || data.data[0].expireDate === '') {
                this.codeEndTime = '-'
              } else {
                this.codeEndTime = data.data[0].expireDate.substr(0, 4) + '-' + data.data[0].expireDate.substr(5, 2) + '-' + data.data[0].expireDate.substr(8, 2) + ' ' + data.data[0].expireDate.substr(11, 2) + ':' + data.data[0].expireDate.substr(14, 2) + ':' + data.data[0].expireDate.substr(17, 2)
              }
              this.bluetoothId = ''
              this.bluetoothNumber = '-'
              this.bluetoothStartTime = '-'
              this.bluetoothEndTime = '-'
            }
            // 蓝牙
            if (data.data[0].passType === 2) {
              this.bluetoothId = data.data[0].id
              this.bluetoothNumber = this.$null(data.data[0].passCode)
              if (data.data[0].effectiveTime === null || data.data[0].effectiveTime === '') {
                this.bluetoothStartTime = '-'
              } else {
                this.bluetoothStartTime = data.data[0].effectiveTime.substr(0, 4) + '-' + data.data[0].effectiveTime.substr(5, 2) + '-' + data.data[0].effectiveTime.substr(8, 2) + ' ' + data.data[0].effectiveTime.substr(11, 2) + ':' + data.data[0].effectiveTime.substr(14, 2) + ':' + data.data[0].effectiveTime.substr(17, 2)
              }
              if (data.data[0].expireDate === null || data.data[0].expireDate === '') {
                this.bluetoothEndTime = '-'
              } else {
                this.bluetoothEndTime = data.data[0].expireDate.substr(0, 4) + '-' + data.data[0].expireDate.substr(5, 2) + '-' + data.data[0].expireDate.substr(8, 2) + ' ' + data.data[0].expireDate.substr(11, 2) + ':' + data.data[0].expireDate.substr(14, 2) + ':' + data.data[0].expireDate.substr(17, 2)
              }
              this.codeId = ''
              this.codeNumber = '-'
              this.codeStartTime = '-'
              this.codeEndTime = '-'
            }
          } else {
            for (var i = 0; i < data.data.length; i++) {
              // 二维码
              if (data.data[i].passType === 1) {
                this.codeId = data.data[i].id
                this.codeNumber = this.$null(data.data[i].passCode)
                this.codeCopyNumber = data.data[i].createTimeStamp
                if (data.data[i].effectiveTime === null || data.data[i].effectiveTime === '') {
                  this.codeStartTime = '-'
                } else {
                  this.codeStartTime = data.data[i].effectiveTime.substr(0, 4) + '-' + data.data[i].effectiveTime.substr(5, 2) + '-' + data.data[i].effectiveTime.substr(8, 2) + ' ' + data.data[i].effectiveTime.substr(11, 2) + ':' + data.data[i].effectiveTime.substr(14, 2) + ':' + data.data[i].effectiveTime.substr(17, 2)
                }
                if (data.data[i].expireDate === null || data.data[i].expireDate === '') {
                  this.codeEndTime = '-'
                } else {
                  this.codeEndTime = data.data[i].expireDate.substr(0, 4) + '-' + data.data[i].expireDate.substr(5, 2) + '-' + data.data[i].expireDate.substr(8, 2) + ' ' + data.data[i].expireDate.substr(11, 2) + ':' + data.data[i].expireDate.substr(14, 2) + ':' + data.data[i].expireDate.substr(17, 2)
                }
              }
              // 蓝牙
              if (data.data[i].passType === 2) {
                this.bluetoothId = data.data[i].id
                this.bluetoothNumber = this.$null(data.data[i].passCode)
                if (data.data[i].effectiveTime === null || data.data[i].effectiveTime === '') {
                  this.bluetoothStartTime = '-'
                } else {
                  this.bluetoothStartTime = data.data[i].effectiveTime.substr(0, 4) + '-' + data.data[i].effectiveTime.substr(5, 2) + '-' + data.data[i].effectiveTime.substr(8, 2) + ' ' + data.data[i].effectiveTime.substr(11, 2) + ':' + data.data[i].effectiveTime.substr(14, 2) + ':' + data.data[i].effectiveTime.substr(17, 2)
                }
                if (data.data[i].expireDate === null || data.data[i].expireDate === '') {
                  this.bluetoothEndTime = '-'
                } else {
                  this.bluetoothEndTime = data.data[i].expireDate.substr(0, 4) + '-' + data.data[i].expireDate.substr(5, 2) + '-' + data.data[i].expireDate.substr(8, 2) + ' ' + data.data[i].expireDate.substr(11, 2) + ':' + data.data[i].expireDate.substr(14, 2) + ':' + data.data[i].expireDate.substr(17, 2)
                }
              }
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getFamilyList () {
      this.$http.get(this.$api.family_list, {
        params: {
          roomId: this.roomId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.familyAttr = data.data.data
          this.familyTotal = data.data.data.length
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    importPic (id) {
      let ownerRoomId = id
      this.picType = 'family'
      if (ownerRoomId === '') {
        this.picType = 'owner'
        ownerRoomId = this.ownerRoomId
      }
      this.$http.get(this.$api.owner_info, {
        params: {
          ownerRoomId: ownerRoomId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          if (data.data.data.roomPics !== '' && data.data.data.roomPics !== null) {
            let photoArr = data.data.data.roomPics.split(',')
            for (let i = 0; i < photoArr.length; i++) {
              this.form.fileList.push({
                picId: photoArr[i],
                url: this.$url + this.$api.file_download + '?id=' + photoArr[i],
                name: '',
                uid: ''
              })
              this.form.fileArr.push({
                picId: photoArr[i],
                url: this.$url + this.$api.file_download + '?id=' + photoArr[i],
                name: '',
                uid: ''
              })
            }
          }
          this.familyRoomId = data.data.data.id
          this.familyCard = data.data.data.idCard
          this.familyName = data.data.data.owner
          this.title = '人脸设置'
          this.dialog = true
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    bluetoothDel () {
      let formData = new FormData()
      formData.append('ids', this.bluetoothId)

      this.$confirm('是否删除蓝牙?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: this.$api.owner_liftcode_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '蓝牙已删除',
              type: 'success',
              duration: 1000
            })

            this.onConnectBluetoothDel()

            this.getLiftCode()
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    codeDel () {
      let formData = new FormData()
      formData.append('ids', this.codeId)

      this.$confirm('是否删除二维码?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: this.$api.owner_liftcode_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '二维码已删除',
              type: 'success',
              duration: 1000
            })

            this.onConnectCodeDel()

            this.getLiftCode()
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    del (id, ownerCodes, pics) {
      this.delFamilyRoomId = id
      let formData = new FormData()
      formData.append('ownerRoomId', id)
      formData.append('status', '-1')
      formData.append('type', 1)

      this.$confirm('是否删除成员?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          method: 'post',
          url: this.$api.owner_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.data.success) {
            this.$message({
              message: '成员已删除',
              type: 'success',
              duration: 1000
            })
            this.familyId = id
            if (ownerCodes === null) {
              this.familyBluetooth = null
              this.familyCode = null
            } else {
              this.familyBluetooth = ownerCodes.BLUE
              this.familyCode = ownerCodes.QR
            }
            this.familyPic = pics
            this.getFamilyList()

            this.client = new window.Paho.MQTT.Client(this.host, Number(this.port), this.clientId)
            let options = {
              invocationContext: {
                host: this.host,
                port: this.port,
                path: this.client.path,
                clientId: this.clientId
              },
              useSSL: this.$useSSL,
              timeout: 10,
              keepAliveInterval: 60,
              cleanSession: true,
              userName: this.username,
              password: this.password,
              onSuccess: this.onConnectFamilyDel,
              onFailure: this.onFailure
            }
            this.client.connect(options)
          } else {
            this.$message({
              type: 'error',
              message: data.data.errMsg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    notBtn () {
      this.$refs.upload.clearFiles()
      this.$refs.form.resetFields()
      this.form.fileList = []
      this.form.fileArr = []
      this.dialog = false
    },
    onConnectPicAdd () {
      // 人脸识别基本参数
      let picParams = {
        passengerType: 1,
        AllowTimes: 65535,
        EffectiveTime: '0',
        ExpiredDate: '0',
        ExecuteTime: '0',
        OperationType: 1,
        singleFloorAutoRegistration: 1,
        Type: 6,
        allowFloor1: this.faceObj.floor
      }
      if (this.picType === 'owner') {
        picParams.Number = this.ownerId
      }
      if (this.picType === 'family') {
        picParams.Number = this.familyId
      }
      if (this.faceObj.door === 'front') {
        picParams.allowDoor1 = 0
      }
      if (this.faceObj.door === 'back') {
        picParams.allowDoor1 = 1
      }

      let items = [] // MQ消息体数组
      // 人脸识别设备
      for (let i = 0; i < this.faceObj.face.length; i++) {
        let topic = '/TYPE04/' + this.faceObj.face[i] + '/info'
        picParams.Url = this.picUrl
        let send = {
          cmd: 'downFaceInfo',
          params: picParams
        }
        items.push({
          topic: topic,
          mqttJson: JSON.stringify(send)
        })
      }

      // 网关
      for (let i = 0; i < this.faceObj.gate.length; i++) {
        let topic = '/TYPE03/' + this.faceObj.gate[i] + '/info'
        picParams.Url = this.picUrl
        let send = {
          cmd: 'downFaceInfo',
          params: picParams
        }
        items.push({
          topic: topic,
          mqttJson: JSON.stringify(send)
        })
      }
      this.$http({
        method: 'post',
        url: this.$api.mqtt_push,
        data: {
          items: items
        }
      }).then((res) => {
        let data = res.data
        if (!data.success) {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onConnectPicDel () {
      // 人脸识别基本参数
      let picParams = {
        passengerType: 1,
        AllowTimes: 65535,
        EffectiveTime: '0',
        ExpiredDate: '0',
        ExecuteTime: '0',
        OperationType: 2,
        singleFloorAutoRegistration: 1,
        Type: 6,
        allowFloor1: this.faceObj.floor
      }
      if (this.picType === 'owner') {
        picParams.Number = this.ownerId
      }
      if (this.picType === 'family') {
        picParams.Number = this.familyId
      }
      if (this.faceObj.door === 'front') {
        picParams.allowDoor1 = 0
      }
      if (this.faceObj.door === 'back') {
        picParams.allowDoor1 = 1
      }

      let items = [] // MQ消息体数组
      // 人脸识别设备
      for (let i = 0; i < this.faceObj.face.length; i++) {
        let topic = '/TYPE04/' + this.faceObj.face[i] + '/info'
        picParams.Url = this.picUrl
        let send = {
          cmd: 'downFaceInfo',
          params: picParams
        }
        items.push({
          topic: topic,
          mqttJson: JSON.stringify(send)
        })
      }

      // 网关
      for (let i = 0; i < this.faceObj.gate.length; i++) {
        let topic = '/TYPE03/' + this.faceObj.gate[i] + '/info'
        picParams.Url = this.picUrl
        let send = {
          cmd: 'downFaceInfo',
          params: picParams
        }
        items.push({
          topic: topic,
          mqttJson: JSON.stringify(send)
        })
      }
      this.$http({
        method: 'post',
        url: this.$api.mqtt_push,
        data: {
          items: items
        }
      }).then((res) => {
        let data = res.data
        if (!data.success) {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onConnectBluetoothDel () {
      // 业主蓝牙基本参数
      let bluetoothParams = {
        passengerType: 1,
        AllowTimes: 65535,
        EffectiveTime: '0',
        ExpiredDate: '0',
        ExecuteTime: '0',
        OperationType: 2,
        singleFloorAutoRegistration: 1,
        Type: 6,
        Number: this.bluetoothNumber,
        allowFloor1: this.faceObj.floor
      }
      if (this.faceObj.door === 'front') {
        bluetoothParams.allowDoor1 = 0
      }
      if (this.faceObj.door === 'back') {
        bluetoothParams.allowDoor1 = 1
      }

      let items = [] // MQ消息体数组
      for (let i = 0; i < this.faceObj.sn.length; i++) {
        let topic = '/TYPE01/' + this.faceObj.sn[i] + '/info'
        let send = {
          cmd: 'downBleInfo',
          params: bluetoothParams
        }
        items.push({
          topic: topic,
          mqttJson: JSON.stringify(send)
        })
      }
      this.$http({
        method: 'post',
        url: this.$api.mqtt_push,
        data: {
          items: items
        }
      }).then((res) => {
        let data = res.data
        if (!data.success) {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onConnectCodeDel () {
      // 业主二维码基本参数
      let codeParams = {
        passengerType: 1,
        AllowTimes: 65535,
        ExecuteTime: '0000-2359',
        OperationType: 2,
        singleFloorAutoRegistration: 1,
        Type: 6,
        Number: this.codeNumber,
        allowFloor1: this.faceObj.floor
      }
      if (this.codeCopyNumber) {
        let timeOld = Number((this.codeCopyNumber / 1000).toFixed(0)).toString(16).toLocaleUpperCase().split('')
        codeParams.AvertCopyNum = [timeOld[0] + timeOld[1], timeOld[2] + timeOld[3], timeOld[4] + timeOld[5], timeOld[6] + timeOld[7]]
      }
      codeParams.EffectiveTime = this.$date4(new Date().getTime()).substr(0, 4) + this.$date4(new Date().getTime()).substr(5, 2) + this.$date4(new Date().getTime()).substr(8, 2) + this.$date4(new Date().getTime()).substr(11, 2) + this.$date4(new Date().getTime()).substr(14, 2)
      codeParams.ExpiredDate = this.$date4(new Date().getTime()).substr(0, 4) + this.$date4(new Date().getTime()).substr(5, 2) + this.$date4(new Date().getTime()).substr(8, 2) + this.$date4(new Date().getTime()).substr(11, 2) + this.$date4(new Date().getTime()).substr(14, 2)
      if (this.faceObj.door === 'front') {
        codeParams.allowDoor1 = 0
      }
      if (this.faceObj.door === 'back') {
        codeParams.allowDoor1 = 1
      }
      if (this.faceObj.groupNum.length === 1) {
        codeParams.GroupNum = '00' + this.faceObj.groupNum
      } else if (this.faceObj.groupNum.length === 2) {
        codeParams.GroupNum = '0' + this.faceObj.groupNum
      } else if (this.faceObj.groupNum.length === 3) {
        codeParams.GroupNum = this.faceObj.groupNum
      }

      let items = [] // MQ消息体数组
      for (let i = 0; i < this.faceObj.sn.length; i++) {
        let topic = '/TYPE01/' + this.faceObj.sn[i] + '/info'
        let send = {
          cmd: 'downQrInfo',
          params: codeParams
        }
        items.push({
          topic: topic,
          mqttJson: JSON.stringify(send)
        })
      }
      this.$http({
        method: 'post',
        url: this.$api.mqtt_push,
        data: {
          items: items
        }
      }).then((res) => {
        let data = res.data
        if (!data.success) {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onConnectFamilyDel () {
      console.log('连接成功')

      // 删除成员所有MQTT
      let params = {
        ownerRoomId: this.delFamilyRoomId,
        status: -1
      }
      let topic = '/TYPE00/' + this.delFamilyRoomId + '/notify'
      let send = {
        cmd: 'handler',
        params: params
      }
      console.log(topic)
      console.log(JSON.stringify(send))
      let message = new window.Paho.MQTT.Message(JSON.stringify(send))
      message.destinationName = topic
      message.qos = 1
      message.retained = false
      this.client.send(message)

      // 人脸识别基本参数
      // let picParams = {
      //   passengerType: 1,
      //   AllowTimes: 65535,
      //   EffectiveTime: '0',
      //   ExpiredDate: '0',
      //   ExecuteTime: '0',
      //   OperationType: 2,
      //   singleFloorAutoRegistration: 1,
      //   Type: 6,
      //   Number: this.familyId,
      //   allowFloor1: this.faceObj.floor
      // }
      // if (this.faceObj.door === 'front') {
      //   picParams.allowDoor1 = 0
      // }
      // if (this.faceObj.door === 'back') {
      //   picParams.allowDoor1 = 1
      // }

      // for (let i = 0; i < this.faceObj.face.length; i++) {
      //   let topic = '/TYPE04/' + this.faceObj.face[i] + '/info'
      //   if (this.familyPic !== null) {
      //     let myPic = this.familyPic.split(',')
      //     for (let i = 0; i < myPic.length; i++) {
      //       picParams.Url = this.$url + this.$api.file_download + '?id=' + myPic[i]
      //       let send = {
      //         cmd: 'downFaceInfo',
      //         params: picParams
      //       }
      //       console.log(topic)
      //       console.log(JSON.stringify(send))
      //       let message = new window.Paho.MQTT.Message(JSON.stringify(send))
      //       message.destinationName = topic
      //       message.qos = 1
      //       message.retained = false
      //       this.client.send(message)
      //     }
      //   }
      // }

      // 业主蓝牙基本参数
      // let bluetoothParams = {
      //   passengerType: 1,
      //   AllowTimes: 65535,
      //   EffectiveTime: '0',
      //   ExpiredDate: '0',
      //   ExecuteTime: '0',
      //   OperationType: 2,
      //   singleFloorAutoRegistration: 1,
      //   Type: 6,
      //   Number: this.familyBluetooth,
      //   allowFloor1: this.faceObj.floor
      // }
      // if (this.faceObj.door === 'front') {
      //   bluetoothParams.allowDoor1 = 0
      // }
      // if (this.faceObj.door === 'back') {
      //   bluetoothParams.allowDoor1 = 1
      // }

      // for (let i = 0; i < this.faceObj.sn.length; i++) {
      //   if (this.familyBluetooth === null) {
      //     break
      //   }
      //   let topic = '/TYPE01/' + this.faceObj.sn[i] + '/info'
      //   let send = {
      //     cmd: 'downBleInfo',
      //     params: bluetoothParams
      //   }
      //   console.log(topic)
      //   console.log(JSON.stringify(send))
      //   let message = new window.Paho.MQTT.Message(JSON.stringify(send))
      //   message.destinationName = topic
      //   message.qos = 1
      //   message.retained = false
      //   this.client.send(message)
      // }

      // 业主二维码基本参数
      // let codeParams = {
      //   passengerType: 1,
      //   AllowTimes: 65535,
      //   ExecuteTime: '0000-2359',
      //   OperationType: 2,
      //   singleFloorAutoRegistration: 1,
      //   Type: 6,
      //   Number: this.familyCode,
      //   allowFloor1: this.faceObj.floor
      // }
      // codeParams.EffectiveTime = this.$date4(new Date().getTime()).substr(0, 4) + this.$date4(new Date().getTime()).substr(5, 2) + this.$date4(new Date().getTime()).substr(8, 2) + this.$date4(new Date().getTime()).substr(11, 2) + this.$date4(new Date().getTime()).substr(14, 2)
      // codeParams.ExpiredDate = this.$date4(new Date().getTime()).substr(0, 4) + this.$date4(new Date().getTime()).substr(5, 2) + this.$date4(new Date().getTime()).substr(8, 2) + this.$date4(new Date().getTime()).substr(11, 2) + this.$date4(new Date().getTime()).substr(14, 2)
      // if (this.faceObj.door === 'front') {
      //   codeParams.allowDoor1 = 0
      // }
      // if (this.faceObj.door === 'back') {
      //   codeParams.allowDoor1 = 1
      // }
      // if (this.faceObj.groupNum.length === 1) {
      //   codeParams.GroupNum = '00' + this.faceObj.groupNum
      // } else if (this.faceObj.groupNum.length === 2) {
      //   codeParams.GroupNum = '0' + this.faceObj.groupNum
      // } else if (this.faceObj.groupNum.length === 3) {
      //   codeParams.GroupNum = this.faceObj.groupNum
      // }

      // for (let i = 0; i < this.faceObj.sn.length; i++) {
      //   if (this.familyCode === null) {
      //     break
      //   }
      //   let topic = '/TYPE01/' + this.faceObj.sn[i] + '/info'
      //   let send = {
      //     cmd: 'downQrInfo',
      //     params: codeParams
      //   }
      //   console.log(topic)
      //   console.log(JSON.stringify(send))
      //   let message = new window.Paho.MQTT.Message(JSON.stringify(send))
      //   message.destinationName = topic
      //   message.qos = 1
      //   message.retained = false
      //   this.client.send(message)
      // }
    },
    onFailure () {
      console.log('连接失败')
    },
    add () {
      this.familyForm.userId = ''
      this.familyDialog = true
      this.familyTitle = '新增成员'
    },
    edit (row) {
      this.familyForm.userId = row.id
      this.familyForm.userName = row.owner
      this.familyForm.userType = row.ownerType
      this.familyForm.userCode = row.idCard
      this.familyForm.phoneNumber = row.phone
      this.familyForm.sex = row.sex
      this.familyDialog = true
      this.familyTitle = '编辑成员'
    },
    familyNotBtn () {
      this.$refs.familyForm.resetFields()
      this.familyForm.userId = ''
      this.familyForm.userName = ''
      this.familyForm.userType = ''
      this.familyForm.userCode = ''
      this.familyForm.phoneNumber = ''
      this.familyForm.sex = ''
      this.familyDialog = false
      this.familyLoading = false
    },
    familyOkBtn () {
      this.$refs.familyForm.validate((valid) => {
        if (valid) {
          this.familyLoading = true

          let api = this.familyForm.userId ? this.$api.family_edit : this.$api.family_add

          let formData = new FormData()
          formData.append('id', this.familyForm.userId)
          formData.append('name', this.familyForm.userName)
          formData.append('idCard', this.familyForm.userCode)
          formData.append('phone', this.familyForm.phoneNumber)
          formData.append('sex', this.familyForm.sex)
          formData.append('roomId', this.roomId)
          formData.append('ownerRoomType', this.familyForm.userType)

          if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.familyForm.phoneNumber)) && this.familyForm.phoneNumber !== '') {
            this.$message({
              type: 'error',
              message: '请输入正确的联系方式',
              duration: 1000
            })
            this.familyLoading = false
          } else {
            this.$http({
              method: 'post',
              url: api,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: this.familyForm.userId ? '编辑成员成功' : '新增成员成功',
                  type: 'success',
                  duration: 1000
                })
                this.familyNotBtn()
                this.getFamilyList()
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.familyLoading = false
            }).catch((err) => {
              console.log(err)
              this.familyLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    upload (file, fileList) {
      let uploadStatus = true // 添加文件是否成功

      if (file.raw.type !== 'image/jpeg' && file.raw.type !== 'image/png' && file.raw.type !== 'image/jpg') {
        this.$message({
          message: '只能上传png、jpg与jpeg格式的图片',
          type: 'warning',
          duration: 1000
        })
        uploadStatus = false
      } else {
        if (file.size > 1024 * 1024 * 2) {
          this.$message({
            message: '只能上传不大于2M的图片',
            type: 'warning',
            duration: 1000
          })
          uploadStatus = false
        }
      }
      // 删除不符合条件的照片
      if (!uploadStatus) {
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].uid === file.uid) {
            this.form.fileList.splice(i, 1)
            break
          }
        }
      }
      if (uploadStatus) {
        let formData = new FormData()
        formData.append('file', file.raw)
        formData.append('orgId', this.villageId)
        formData.append('building', this.ownerInfo.building)
        formData.append('unit', this.ownerInfo.unit)
        if (this.picType === 'owner') {
          formData.append('idCard', this.ownerCode)
          formData.append('name', this.ownerName)
        }
        if (this.picType === 'family') {
          formData.append('idCard', this.familyCard)
          formData.append('name', this.familyName)
        }
        let info = {
          building: this.ownerInfo.building,
          unit: this.ownerInfo.unit,
          floor: this.ownerInfo.json.floor.toString(),
          house: this.ownerInfo.room,
          door: this.ownerInfo.json.door
        }
        formData.append('info', JSON.stringify(info))

        this.$http({
          method: 'post',
          url: this.$api.file_upload,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.picId = data.data.split('id=')[1]
            this.picUrl = this.$url + this.$api.file_download + '?id=' + data.data.split('id=')[1]

            let picArr = []
            for (let i = 0; i < this.form.fileArr.length; i++) {
              picArr.push(this.form.fileArr[i].picId)
            }
            picArr.push(this.picId)

            let userId = ''
            if (this.picType === 'owner') {
              userId = this.ownerRoomId
            }
            if (this.picType === 'family') {
              userId = this.familyRoomId
            }
            this.$http({
              method: 'post',
              url: this.$api.owner_pic_add,
              data: {
                id: userId,
                roomPics: picArr
              }
            }).then((res) => {
              let data = res.data

              if (data.data.success) {
                this.$message({
                  message: '更新人脸成功',
                  type: 'success',
                  duration: 1000
                })
                this.form.fileArr.push({
                  picId: this.picId,
                  url: this.picUrl,
                  name: '',
                  uid: file.uid
                })
                if (this.picType === 'owner') {
                  this.getOwnerInfo()
                }

                // this.onConnectPicAdd()
              } else {
                this.$message({
                  type: 'error',
                  message: data.data.errMsg,
                  duration: 1000
                })
                // 删除上传失败的照片
                for (let i = 0; i < fileList.length; i++) {
                  if (fileList[i].uid === file.uid) {
                    this.form.fileList.splice(i, 1)
                    break
                  }
                }
              }
            }).catch((err) => {
              console.log(err)
              // 删除上传失败的照片
              for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].uid === file.uid) {
                  this.form.fileList.splice(i, 1)
                  break
                }
              }
            })
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
            // 删除上传失败的照片
            for (let i = 0; i < fileList.length; i++) {
              if (fileList[i].uid === file.uid) {
                this.form.fileList.splice(i, 1)
                break
              }
            }
          }
        }).catch((err) => {
          console.log(err)
          // 删除上传失败的照片
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].uid === file.uid) {
              this.form.fileList.splice(i, 1)
              break
            }
          }
        })
      }
    },
    explainFile (file, fileList) {
      this.$message({
        message: '最多上传6张照片',
        type: 'warning',
        duration: 1000
      })
    },
    delFile (file, fileList) {
      let formData = new FormData()
      if (file.picId === '' || file.picId === null || file.picId === undefined) {
        for (let i = 0; i < this.form.fileArr.length; i++) {
          if (this.form.fileArr[i].uid === file.uid) {
            formData.append('id', this.form.fileArr[i].picId)
            break
          }
        }
      } else {
        formData.append('id', file.picId)
      }
      formData.append('orgId', this.villageId)
      formData.append('building', this.ownerInfo.building)
      formData.append('unit', this.ownerInfo.unit)
      if (this.picType === 'owner') {
        formData.append('idCard', this.ownerCode)
        formData.append('name', this.ownerName)
      }
      if (this.picType === 'family') {
        formData.append('idCard', this.familyCard)
        formData.append('name', this.familyName)
      }
      let info = {
        building: this.ownerInfo.building,
        unit: this.ownerInfo.unit,
        floor: this.ownerInfo.json.floor.toString(),
        house: this.ownerInfo.room,
        door: this.ownerInfo.json.door
      }
      formData.append('info', JSON.stringify(info))

      this.$http({
        method: 'post',
        url: this.$api.file_delete,
        data: formData
      }).then((res) => {
        let data = res.data

        if (data.success) {
          console.log('删除人脸成功')
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      for (let i = 0; i < this.form.fileArr.length; i++) {
        this.picId = this.form.fileArr[i].picId
        this.picUrl = this.form.fileArr[i].url
        // 原先就有的图片
        if (this.form.fileArr[i].url === file.url) {
          this.form.fileArr.splice(i, 1)
          break
        }
        // 先新增的图片
        if (this.form.fileArr[i].uid === file.uid) {
          this.form.fileArr.splice(i, 1)
          break
        }
      }
      let picArr = []
      for (let i = 0; i < this.form.fileArr.length; i++) {
        picArr.push(this.form.fileArr[i].picId)
      }

      let userId = ''
      if (this.picType === 'owner') {
        userId = this.ownerRoomId
      }
      if (this.picType === 'family') {
        userId = this.familyRoomId
      }
      this.$http({
        method: 'post',
        url: this.$api.owner_pic_add,
        data: {
          id: userId,
          roomPics: picArr
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.$message({
            message: '更新人脸成功',
            type: 'success',
            duration: 1000
          })
          if (this.picType === 'owner') {
            this.getOwnerInfo()
          }

          // this.onConnectPicDel()
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
          let myFileList = []
          for (let i = 0; i < this.form.fileList.length; i++) {
            myFileList.push(this.form.fileList[i])
          }
          this.form.fileList = myFileList
          this.form.fileArr.push({
            picId: this.picId,
            url: this.picUrl,
            name: file.name,
            uid: file.uid
          })
        }
      }).catch((err) => {
        console.log(err)
        let myFileList = []
        for (let i = 0; i < this.form.fileList.length; i++) {
          myFileList.push(this.form.fileList[i])
        }
        this.form.fileList = myFileList
        this.form.fileArr.push({
          picId: this.picId,
          url: this.picUrl,
          name: file.name,
          uid: file.uid
        })
      })
    },
    getSex (val) {
      switch (val) {
        case 0:
          return '女'
        case 1:
          return '男'
      }
    },
    byLiftRecord (familyId, roomId, familyName) {
      this.$router.push('ownerFamilyByLift?familyId=' + familyId + '&roomId=' + roomId + '&villageId=' + this.villageId + '&ownerName=' + encodeURI(encodeURI(this.ownerName)) + '&ownerId=' + this.ownerId + '&ownerRoomId=' + this.ownerRoomId + '&familyName=' + encodeURI(encodeURI(familyName)))
    },
    notData (str) {
      return this.$null(str)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.ownerDetail
  box-sizing border-box
  padding 80px 0 20px 20px
  width 100%
  min-height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
  .contentWrap
    box-sizing border-box
    display flex
    margin-top 20px
    padding-right 20px
    .infoWrap
      box-sizing border-box
      position relative
      flex 2
      margin-right 20px
      padding 20px
      min-height 420px
      background #fff
      box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
      border-radius 4px
      .infoHeader
        line-height 20px
        font-size 16px
        font-weight bold
        color #333
      .myBtn
        position absolute
        top 20px
        right 20px
      .infoDiv
        margin-top 16px
        line-height 18px
        font-size 14px
        .infoTitle
          display inline-block
          width 84px
          color #666
          text-align right
          vertical-align top
        .infoContent
          display inline-block
          color #333
          vertical-align top
      .notImage
        margin-top 18px
        width 96px
        height 96px
        line-height 96px
        font-size 12px
        color #999
        text-align center
        background-image url('./no_pic.png')
        background-repeat no-repeat
        background-size 100% 100%
      .photo
        display inline-block
        margin-top 18px
        margin-left 8px
        &:first-of-type
          margin-left 0
    .otherWrap
      flex 1
      .bluetoothWrap
        box-sizing border-box
        position relative
        padding 20px
        width 100%
        height calc((100% - 20px) / 2)
        background-color #fff
        background-image url('./bluetooth.png')
        background-repeat no-repeat
        background-position bottom right
        box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
        border-radius 4px
        .bluetoothHeader
          margin-bottom 8px
          line-height 20px
          font-size 16px
          font-weight bold
          color #333
        .bluetoothDiv
          margin-top 16px
          line-height 18px
          font-size 14px
          .bluetoothTitle
            display inline-block
            width 84px
            color #666
            text-align right
            vertical-align top
          .bluetoothContent
            display inline-block
            color #333
            vertical-align top
        .delBtn
          position absolute
          top 20px
          right 20px
      .codeWrap
        box-sizing border-box
        position relative
        margin-top 20px
        padding 20px
        width 100%
        height calc((100% - 20px) / 2)
        background-color #fff
        background-image url('./QR_code.png')
        background-repeat no-repeat
        background-position bottom right
        box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
        border-radius 4px
        .codeHeader
          margin-bottom 8px
          line-height 20px
          font-size 16px
          font-weight bold
          color #333
        .codeDiv
          margin-top 16px
          line-height 18px
          font-size 14px
          .codeTitle
            display inline-block
            width 84px
            color #666
            text-align right
            vertical-align top
          .codeContent
            display inline-block
            color #333
            vertical-align top
        .delBtn
          position absolute
          top 20px
          right 20px
  .tableWrap
    margin-top 20px
    margin-right 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .tableTitle
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 16px
      color #333
      .explain
        font-size 12px
        color #999
    .addBtn
      float right
      margin-right 20px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
        .userType
          display inline-block
          width 16px
          height 16px
          background-repeat no-repeat
          background-size 100% 100%
          vertical-align sub
          &.owner
            background-image url('./owner.png')
          &.family
            background-image url('./family.png')
          &.tenant
            background-image url('./tenant.png')
          &.property
            background-image url('./property.png')
        .autho
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
        .el-upload
          width 96px
          height 96px
          line-height 96px
        .el-upload-list__item
          width 96px
          height 96px
        .uploadText
          display block
          height 32px
          margin-top -70px
          font-size 14px
          color #333
        .el-upload__tip
          width 208px
          line-height 22px
          font-size 14px
          color rgba(0, 0, 0, .45)
</style>



// WEBPACK FOOTER //
// src/components/user/ownerDetail.vue